/*
 
Skórki Material

 
*/

import * as M from '@material-ui/core';

//import './theme.css'

// https://in-your-saas.github.io/material-ui-theme-editor/
// http://mcg.mbitson.com/#!?mcgpalette0=%2338920a&mcgpalette2=%2326a69a&themename=rez1
// https://www.materialpalette.com/blue/lime

//https://material-ui.com/style/color/

// material

// po wpisaniu do pliku:
//import themeProject from './cfg/theme.json';

const theme = M.createTheme({
  //  palette: appPalette,
  palette: {
    primary: { light: "rgba(69, 139, 0, 0.5)", main: "#458B00", dark: '#69b076' },    //light: green[50]
    secondary: { light: "rgb(232, 240, 254)", main: "#3a87ad", dark: "#005a7e" },
    error: { main: "rgb(244, 67, 54)" },
    text: { secondary: "#555" }
  },
  //palette : themeProject.palette,
  typography: {
    /*?? */
    //   useNextVariants: true, 
  },
  overrides: {
    MuiButton: {
      root:{
        textTransform: "none" as "none"
      }
    },
    MuiTableCell: {
      root: {
        padding: "14px 5px 14px 16px"
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: "8px 14px",
        textAlign: "center",
        fontWeight: "bold"
      },
      multiline: {
        padding: "0px"
      }
    },
    MuiSelect: {
      selectMenu: {
        fontWeight: 400
      }
    },
    MuiCheckbox: {
      root: {
        color: "#458B00",
      }
    },
    MuiFormControl: {
      marginNormal: {
        marginBottom: "10px"
      }
    },
    MuiIconButton: {
      root: {
          padding: "0px",
          color: "#458B00"
      }
  },
  },
}
)

/*
const styleAppBar = (theme : any) => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
})  
  
styleAppBar,
*/

/*const styles = createStyles(appPalette);

export { styles,  appPalette }
*/
export default theme

export const ThemeOrange = M.createTheme({
  palette: {
    primary: {
      main: "#e65100",
    },
    secondary: {
      main: "#3a87ad",
    },
  },
});

export const kolory = {
  green: theme.palette.primary.main, //"#8ac926",                                               //theme.palette.primary.main, //"rgb(132 0 139)",//

  blue:  theme.palette.secondary.main, // "#1982c4",                                               //            theme.palette.secondary.main,
  darkBlue: "rgb(0, 90, 126)",  ///

  lightBrown: "#6a4c93",                                                     //    'rgba(191, 136, 85, 0.8)', ///

  orange: "rgb(255, 140, 0)", //theme.palette.error.main,    //"#ffca3a",                                                    //theme.palette.error.main,
  darkOrange: "#e65100",                                          //    "#e65100", //#ff595e
};